import { useQueryClient } from '@tanstack/react-query'
import { DirectoFormValues } from '../models/schema'
import { createDirectoEvent } from '../api/createDirectoEvent'
import { updateDirectoEvent } from '../api/updateDirectoEvent'
import { DirectoEvent } from '../models/types'
import { QueryKeys } from '../../../../key-registry'

function useSaveDirectoForm(directoEventId: number | null, transitOperationId: number) {
  const queryClient = useQueryClient()

  const saveDirectoFormValues = async ({
    values,
  } : {
    values: DirectoFormValues
  }): Promise<DirectoEvent> => {
    const directoEvent = directoEventId == null
      ? await createDirectoEvent(transitOperationId, values)
      : await updateDirectoEvent(directoEventId, transitOperationId, values)

    queryClient.setQueryData(QueryKeys.directoEvent.detailsByParams({ transitOperationId }), directoEvent)

    return directoEvent
  }

  return {
    saveDirectoFormValues,
  }
}

export default useSaveDirectoForm
